import type { TemplateCheck } from '@reditelji/shared';

/**
 * What is wrong with a body, said plainly.
 *
 * On a template none of it blocks a save — a template mid-edit is allowed to
 * be unfinished — but a typo'd name would otherwise reach an inbox as literal
 * braces. On an obvestilo (`blocking`) the same findings stop the send, so the
 * words say that instead of describing what the mail would look like.
 */
export function Warnings({
  check,
  unresolved,
  blocking = false,
}: {
  check: TemplateCheck;
  unresolved: string[];
  blocking?: boolean;
}) {
  const unknown = [...new Set([...check.unknown, ...unresolved])].filter(
    (name) => !(check.notAllowed as readonly string[]).includes(name),
  );
  if (
    unknown.length === 0 &&
    check.notAllowed.length === 0 &&
    check.missing.length === 0 &&
    check.blockInSubject.length === 0
  ) {
    return null;
  }
  return (
    <div className="ml-warnings">
      {unknown.length > 0 ? (
        <div className="ml-error">
          Ni takšne oznake: {unknown.join(', ')}.{' '}
          {blocking
            ? 'Obvestilo ne gre, dokler je v besedilu.'
            : 'V sporočilu bo izpisana dobesedno.'}
        </div>
      ) : null}
      {check.notAllowed.length > 0 ? (
        <div className="ml-error">
          {blocking ? 'Obvestilo ne pozna oznak' : 'Ta predloga ne pozna oznak'}:{' '}
          {check.notAllowed.join(', ')}.
          {blocking ? ' Obvestilo ne gre, dokler so v besedilu.' : ''}
        </div>
      ) : null}
      {check.blockInSubject.length > 0 ? (
        <div className="ml-warn">
          V zadevi je oznaka za cel odstavek: {check.blockInSubject.join(', ')}. Zadeva je ena
          vrstica — vsebina se bo stisnila vanjo.
        </div>
      ) : null}
      {check.missing.length > 0 ? (
        <div className="ml-warn">
          Manjka {check.missing.join(', ')} — brez tega prostovoljec nima poti do brifinga.
        </div>
      ) : null}
    </div>
  );
}
